import axios from 'axios';

import BannersEditar from '../types/BannersEditar';


async function GuardarBanner(prmBanner: BannersEditar) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_banner"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "banner": {
                "id": prmBanner.id,
                "titulo": prmBanner.titulo,
                "enlace": prmBanner.enlace,
                "habilitado": prmBanner.habilitado,
                "mostrar_web": prmBanner.mostrar_web,
                "fchalta": prmBanner.fchalta,
                "fchmodificado": prmBanner.fchmodificado,
                "dado_baja": prmBanner.dado_baja,
                "fchbaja": prmBanner.fchbaja,
                "banner_mime": prmBanner.banner_mime,
                "banner_content": prmBanner.banner_content,
                "banner_name": prmBanner.banner_name
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarBanner;